import jqRequest from '../jqRequest'
import galleryUrls from '../urls/gallery'

export default {
  // 获取图集详情
  getGalleryDetailById(data) {
    return jqRequest.requestWithToken(galleryUrls.getGalleryDetailById, data);
  },
}